import { useEffect } from "react";
import ProtectedPage from "../components/layout/protected-page";
import { useCurrentStep } from "../store/useSteps";
import LayoutSideBarTopBar from "../components/layout/layout-sidebar-topbar";
import Home from "../components/sections/home";

export default function index() {
  const { step, setCurrentStep, setBreadcrumbs } = useCurrentStep();
  const currentSteps = [
    {
      path: "/",
      label: "Busqueda de personas",
      onClick: () => setCurrentStep(1),
    },
  ];
  useEffect(() => {
    const filteredSteps = currentSteps.filter((_, index) => index < step);
    setBreadcrumbs(filteredSteps);
  }, [step, setBreadcrumbs]);

  return (
    <ProtectedPage>
      <LayoutSideBarTopBar>
        <Home />
      </LayoutSideBarTopBar>
    </ProtectedPage>
  );
}
